import type {
	FollowUpAgentStatusEnum,
	OrderDetailResponseDto,
} from "Infrastructure/Api/Api";
import { useFollowupStatus } from "Order/Hooks/useFollowupStatus";
import { OrderInfoCard, type OrderInfoItem } from "./OrderInfoCard";

type AgentCardProps = {
	order?: OrderDetailResponseDto;
};

export function AgentCard({ order }: AgentCardProps) {
	const { renderFollowupStatus } = useFollowupStatus();

	const items: OrderInfoItem[] = [
		{
			icon: null,
			label: "",
			value: renderFollowupStatus(
				order?.followUpAgentStatus as FollowUpAgentStatusEnum,
			).text,
			show: true,
			spacing: 0,
			isChip: true,
			color: renderFollowupStatus(
				order?.followUpAgentStatus as FollowUpAgentStatusEnum,
			).color,
		},
	];

	return <OrderInfoCard title="Followup Status" items={items} />;
}
